import { useRef } from "react";
import { useRouter } from "next/router";
import styles from "./styles.module.scss";

export const HomeHero = ({
  className = "",
  title = "Find your next role",
  jobsCount = 0,
  searchPath = "/jobs",
  video = "/videos/home_hero.mp4", // pass in your mp4 path
}) => {
  const router = useRouter();
  const inputRef = useRef(null);
  const inputId = "home-input";

  function doSearch() {
    const value = (inputRef.current?.value || "").trim();
    const query = value ? { query: value } : {};
    router.push({ pathname: searchPath, query });
  }

  const handleKeyDown = (e) => {
    if (e.key === "Enter") doSearch();
  };

  return (
    <section className={`${styles.hero} ${className}`}>
      {/* Background video driven by prop */}
      <video
  key={video}
  autoPlay
  loop
  playsInline
  muted
  controls
  poster="/videos/home_hero.jpg"
  className={styles.bg_video}
  style={{ outline: "4px solid magenta" }}   // TEMP: visual proof
  onLoadedData={() => console.log("Video loaded:", video)}
  onError={(e) => console.warn("Video error:", e?.currentTarget?.error)}
>
  <source src={video || "/videos/home_hero.mp4"} type="video/mp4" />
  {/* Optional fallback */}
  {/* <source src="/videos/home_hero.webm" type="video/webm" /> */}
</video>


      {/* Title */}
      <h1
        className={styles.title}
        data-sourceflow-prop="title"
        dangerouslySetInnerHTML={{ __html: title }}
      />

      {/* Search */}
      <div className={styles.search}>
        <input
          id={inputId}
          ref={inputRef}
          className={styles.input}
          onKeyDown={handleKeyDown}
          placeholder={`Type to search from ${jobsCount} jobs`}
          aria-label="Search jobs"
          data-sourceflow-prop="jobsCount"
        />
        <button
          type="button"
          className={styles.iconCont}
          onClick={doSearch}
          aria-label="Search"
        >
          {/* Magnifier icon */}
          <svg
            className={styles.icon}
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            aria-hidden="true"
          >
            <circle cx="11" cy="11" r="7" stroke="white" strokeWidth="2" />
            <line
              x1="16.65"
              y1="16.65"
              x2="22"
              y2="22"
              stroke="white"
              strokeWidth="2"
            />
          </svg>
        </button>
      </div>
    </section>
  );
};

export default HomeHero;
